export enum NoteContext {
  finance = 'finance',
  followUp = 'followUp',
  onHold = 'onHold',
  error = 'error',
  cancel = 'cancel',
  adjustments = 'adjustments',
  client = 'client',
}
